export default __webpack_public_path__ + "static/media/main_gif_mob.19d4ff51.gif";